import { useQuery } from '@tanstack/react-query';
import { fetchResources } from 'src/models/resource/resource';

import { BaseSelect, SelectProps, createFormSelect } from './BaseSelect';

type ResourceSelectProps = Omit<SelectProps, 'options' | 'loading'>;

export const ResourceSelect = (props: ResourceSelectProps) => {
  const { data: resources, isLoading } = useQuery({
    queryKey: ['resources'],
    queryFn: async () => {
      const response = await fetchResources({ fetchAll: true });
      return response || [];
    },
    staleTime: 60000,
    gcTime: 60000,
  });

  const options = (resources || []).map((resource) => ({
    id: resource.id.toString(),
    label: resource.name,
  }));

  return <BaseSelect {...props} options={options} loading={isLoading} />;
};

export const FormResourceSelect = createFormSelect(ResourceSelect);
